<div ngModelGroup="address">
    <div class="_form m-t"
         [grid]="doubleColumnSize"
         [gridColumnGap]="'16px'"
         [gridRowGap]="'16px'">
        @if(!showOnlyAddress) {
        <!-- First Name -->
        <form-mui-field [label]="'First name'| translate"
                        [gridColumn]="1">
            <input type="text"
                   name="firstname"
                   cy-addressaddfirstname
                   [(ngModel)]="data.firstname"
                   (blur)="onInputBlur()"
                   autocomplete="given-name"
                   required>
        </form-mui-field>

        <!-- Last Name -->
        <form-mui-field [label]="'Last name'| translate"
                        [gridColumn]="1">
            <input type="text"
                   name="lastname"
                   cy-addressaddlastname
                   [(ngModel)]="data.lastname"
                   (blur)="onInputBlur()"
                   autocomplete="family-name"
                   required>
        </form-mui-field>

        <!-- Company -->
        <form-mui-field [label]="'Company'| translate"
                        [gridColumn]="1">
            <input type="text"
                   name="company"
                   [(ngModel)]="data.company"
                   (blur)="onInputBlur()"
                   autocomplete="organization">
        </form-mui-field>

        <!--Phone-->
        <div>
            <form-mui-field [label]="('Phone'| translate)"
                            [gridColumn]="doubleColumnSize">
                <input type="text"
                       name="telephone"
                       validatePattern="telephone"
                       inputmode="numeric"
                       cy-addressAddPhone
                       (blur)="onInputBlur()"
                       [(ngModel)]="data.telephone"
                       autocomplete="tel"
                       required>
            </form-mui-field>
            <p class="c1 col-12 m-t-1 p-l-4"> {{ 'Please provide a mobile number for delivery tracking' |
                translate }}</p>
        </div>
        }

        <!--Country-->
        @if(!lockedAddress) {
        @if(!lockedPostcode) {
        @if(showCountry !== 2) {
        <form-mui-field [label]="('Country'| translate)"
                        [gridColumn]="doubleColumnSize">
            <select name="country"
                    autocomplete="country"
                    cy-addressAddCountry
                    [(ngModel)]="data.country_id"
                    (change)="onCountryChange()"
                    required>
                @for (country of countries | orderBy: ['name']; track $index) {
                <option [value]="country.code">{{country.name| translate}}</option>
                }
            </select>
        </form-mui-field>
        }
        @if (searcher) {
        <!-- query -->
        <!-- NOTE: magic with readonly is for autocomplete to skip field -->
        <form-mui-field [label]="('Search for Your address'| translate)"
                        [gridColumn]="doubleColumnSize"
                        [busy]="searcher.status.busy"
                        [hideSideIcon]="true">
            <input type="text"
                   name="query"
                   [(ngModel)]="searcher.query"
                   (keyup)="triggerSearcher()"
                   (blur)="onInputBlur()"
                   autocomplete="off"
                   role="presentation">
            <!-- searcher outlet -->
            <div class="pos-relative"
                 (offClick)="clearSearch()">
                <div class="pos-absolute z-1"
                     [style.width.%]="100">
                    <hide-up [open]="searchVisible$">
                        <div class="bg-col-w b-col-1 b-t-0 custom-scrollbar b-a"
                             [style.maxHeight.px]="300">
                            @if (searcher.hints?.length) {
                            @for (hint of searcher.hints; track searcher.trackByHint($index, hint); let last = $last) {
                            <p class="cursor-pointer p1 p-t-3 p-b-3 p-l-6 p-r-6"
                               [class.b-b]="!last"
                               (click)="searcher.search(hint)"
                               role="option">
                                {{hint['Text']}} {{hint['Description']}}
                            </p>
                            }
                            <result [status]="searcher.status"></result>
                            }
                        </div>
                    </hide-up>
                </div>
            </div>
        </form-mui-field>
        }
        }

        <div>
            <!--Post Code-->
            <form-mui-field [label]="('Post Code'| translate)"
                            [gridColumn]="1">
                <input type="text"
                       name="postcode"
                       cy-addressAddPostcode
                       autocomplete="postal-code"
                       [disabled]=!!lockedPostcode
                       (blur)="onInputBlur()"
                       [(ngModel)]="postcode"
                       (keyup)="triggerSearcher()"
                       (blur)="clearSearch(); onInputBlur()"
                       required>
                @if(!lockedPostcode) {

                }
            </form-mui-field>
            @if(lockedPostcode) {
            <button class="m-t-2"
                    [buttonStyle]="'inlineButton'"
                    (click)="changePostcode()">
                <p class="s2">{{ 'Change postcode'|translate }}</p>
            </button>
            }
        </div>
        <!--Street Name-->
        <form-mui-field [label]="('Address line 1'| translate)"
                        [gridColumn]="doubleColumnSize">
            <input type="text"
                   name="street_1"
                   cy-addressAddFirstLine
                   [(ngModel)]="data.street_1"
                   autocomplete="address-line1"
                   required>

        </form-mui-field>

        <form-mui-field [label]="('Address line 2'| translate)"
                        [gridColumn]="doubleColumnSize">
            <input type="text"
                   name="street_2"
                   [(ngModel)]="data.street_2"
                   autocomplete="address-line2">
        </form-mui-field>

        <!--Town-->
        <form-mui-field [label]="('Town'| translate)"
                        [gridColumn]="1">
            <input type="text"
                   name="city"
                   (blur)="onInputBlur()"
                   cy-addressAddCity
                   autocomplete="address-level2"
                   [(ngModel)]="data.city"
                   required>
        </form-mui-field>



        <!--Region-->
        @if (regionRequired) {
        @if (!regions) {
        <form-mui-field [label]="('Region'| translate)"
                        [gridColumn]="doubleColumnSize"
                        [hideSideIcon]="!regionRequired">
            <input type="text"
                   name="region"
                   cy-addressAddRegion
                   (blur)="onInputBlur()"
                   [(ngModel)]="data.region"
                   autocomplete="address-level1"
                   [required]="regionRequired">
        </form-mui-field>
        }
        @if (regions) {
        <form-mui-field [label]="('Region'| translate)"
                        [gridColumn]="doubleColumnSize"
                        [hideSideIcon]="!regionRequired">
            <select name="region_id"
                    cy-addressAddRegionId
                    (blur)="onInputBlur()"
                    [(ngModel)]="data.region_id"
                    autocomplete="address-level1"
                    [required]="regionRequired">
                <option value=""></option>
                @for (region of regions | orderBy: ['name']; track trackByCode($index, region)) {
                <option [value]="region.id">{{region.name}}</option>
                }
            </select>
        </form-mui-field>
        }
        }
        }

    </div>

</div>